<div class="wrapper">
  <div class="container">
    <div class="info">
      <label for="name">Larmkriterienamn</label>
      <input type="text" disabled [value]="kriterium.name" />
      <label for="species">Smittämne</label>
      <input type="text" disabled [value]="kriterium.species" />
      <label for="type">Typ av larm</label>
      <input
        type="text"
        disabled
        [value]="larmTyp"
      />
      <label for="status">Status</label>
      <input type="text" disabled [value]="kriterium.status === 'AKTIV' ? 'Aktivt' : 'Inaktivt'" />
    </div>
    <div class="antibiotika" *ngIf="antibiotics.length > 0">
      <h3>Antibiotika</h3>
      <div class="mb-4" *ngFor="let antibiotikaGroup of antibiotics; let index = index">
        <div class="eller-grid">
          <p-accordion *ngFor="let antibiotika of antibiotikaGroup">
            <p-accordion-panel>
              <p-accordion-header>{{ antibiotika.name }}</p-accordion-header>
              <p-accordion-content>
                <ul class="list-group">
                  <li class="list-group-item" *ngIf="antibiotika.sir !== '-- Välj --'">SIR: {{ antibiotika.sir }}</li>
                  <li class="list-group-item" *ngIf="antibiotika.zon">Zon: < {{ antibiotika.zon }} mm</li>
                  <li class="list-group-item" *ngIf="antibiotika.tolk !== '-- Välj --'">Tolk MIC: {{ antibiotika.tolk }}</li>
                  <li class="list-group-item" *ngIf="antibiotika.mic">MIC: > {{ antibiotika.mic }} mg/L</li>
                </ul>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </div>
        <label *ngIf="index < antibiotics.length - 1" class="mt-4">Och</label>
      </div>
    </div>

    @if (hasEditRights) {
      <div class="d-flex gap-2 justify-content-end mt-4">
        <app-button
          icon="fas fa-copy"
          text="Kopiera och skapa nytt"
          buttonStyle="secondary"
          (click)="copyLarmkriterie(kriterium)"
        ></app-button>
        <app-button
          icon="fas fa-pencil"
          text="Ändra"
          buttonStyle="primary"
          (click)="editLarmkriterie(kriterium)"
        ></app-button>
      </div>
    }
  </div>
  <div>
    <div class="container">
      <h3>Analyser</h3>
      <div class="analyser">
        <div *ngIf="kriterium.analysis.length === 0 || kriterium.analysis.length === 128; else analyser">
          Alla analyser valda
        </div>
        <ng-template #analyser>
          <div *ngFor="let analys of kriterium.analysis">
            {{ analys }}
          </div>
        </ng-template>
      </div>
    </div>
    <div class="container">
      <h3>Provmaterial</h3>
      <div class="provmaterial">
        <div
          *ngIf="kriterium.sampleMaterials.length === 0 || kriterium.sampleMaterials.length === 128; else provmaterial"
        >
          Alla provmaterial valda
        </div>
        <ng-template #provmaterial>
          <div *ngFor="let material of kriterium.sampleMaterials">
            {{ material }}
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
